module.exports = __webpack_public_path__ + "img/DESIGN_03_prew.f93ded87.jpg";